import { ContractRule } from "@/business/shared/commons/validator/validatorsTypes";

export class NumericRule implements ContractRule {
  esValidationMessage: string;

  constructor(esValidationMessage: string) {
    this.esValidationMessage = esValidationMessage;
  }

  check(value: string, otherValue?: string): boolean {
    return value === "" ? true : !isNaN(Number(value));
  }
}
